import { useEffect, useState } from "react";
import { CONTACTS_APIS } from "../../../../common/apis";
import useFetch from "../../../../hooks/useFetch";
import { toDateTimeFormat } from "../../../../utils";
import ConfirmModal from "./../../../../components/ConfirmModal";
import AppDialog from "./../../../../components/AppDialog";
import NewDataTable, { NewDataGridAction } from "../../../../components/NewDataTable";

export default function ContactAccessSubscriptionsTable({
  data,
  getData,
  rowSelected,
  username,
  ...props
}) {
  const { get } = useFetch();
  const [subId, setSubId] = useState(0)
  const [columnVisibility, setColumnVisibility] = useState({ Customer: false, Site: false, Unit: false, Component: false, SiteSet: false });

  useEffect(() => {
    if (data) {
      let columnsToDisplay = { ...columnVisibility };
      if (data?.filter(i => i.LevelText === 'Customer')?.length > 0) {
        columnsToDisplay = { ...columnsToDisplay, Customer: true };
      }
      if (data?.filter(i => i.LevelText === 'Site')?.length > 0) {
        columnsToDisplay = { ...columnsToDisplay, Customer: true, Site: true };
      }
      if (data?.filter(i => i.LevelText === 'Unit')?.length > 0) {
        columnsToDisplay = { ...columnsToDisplay, Customer: true, Site: true, Unit: true };
      }
      if (data?.filter(i => i.LevelText === 'Component')?.length > 0) {
        columnsToDisplay = { ...columnsToDisplay, Customer: true, Site: true, Unit: true, Component: true };
      }
      if (data?.filter(i => i.LevelText === 'Site Set')?.length > 0) {
        columnsToDisplay = { ...columnsToDisplay, SiteSet: true };
      }
      setColumnVisibility(columnsToDisplay)
    }
  }, [data])

  async function deleteClick(row) {
    setSubId(row?.SubscriptionId)
  }

  const handleDeleteSubscription = async () => {
    setSubId(0);
    await get(`${CONTACTS_APIS.DELETE_CONTACT_SUBSCRIPTION}?SubscriptionId=${subId}&Screen=Contact Subscriptions`);
    getData && getData();
  }

  const options = {
    ...props,
    columns: GetContactAccessSubscriptionsColumns(deleteClick),
    dataSource: data,
    getRowId: (originalRow) => originalRow.SubscriptionId,
    enableColumnActions: false,
    sx: { height: "60dvh", },

    cellStylingHandler: "contactSubscriptionsTable",
    rowsSelected: function (r) {
      r.length && rowSelected(r[0]);
    },

    state: { columnVisibility }, //manage columnVisibility state
    onColumnVisibilityChange: setColumnVisibility,

    muiTableBodyCellProps: ({ cell, column, row, table }) => {
      return {
        sx: cell.column.columnDef.accessorKey === "IsMonthly" ? {
          backgroundColor: (row?.original?.IsMonthly === true ? "green!important" : "") || "",
          color: "white",
          border: "0.5px solid #d0d0d0",
          py: 0,
        } : cell.column.columnDef.accessorKey === "IsWeekly" ? {
          backgroundColor: (row?.original?.IsWeekly === true ? "green!important" : "") || "",
          color: "white",
          border: "0.5px solid #d0d0d0",
          py: 0,
        } : cell.column.columnDef.accessorKey === "Product" ? {
          backgroundColor: (row?.original?.ProductColour + "!important") || "",
          color: "white",
          border: "0.5px solid #d0d0d0",
          py: 0,
        } : { height: "8px", borderLeft: "0.5px solid #d0d0d0", }
      }
    },

    muiTableBodyProps: {
      sx: (theme) => ({
        '& tr:nth-of-type(odd):not([data-selected="true"]):not([data-pinned="true"]) > td':
          { backgroundColor: "inherit" },
        '& tr:nth-of-type(odd):not([data-selected="true"]):not([data-pinned="true"]):hover > td':
          { backgroundColor: "inherit" },
        '& tr:nth-of-type(even):not([data-selected="true"]):not([data-pinned="true"]) > td':
          { backgroundColor: "#e2f2ff" },
        // backgroundColor: "inherit",//
        '& tr:nth-of-type(even):not([data-selected="true"]):not([data-pinned="true"]):hover > td':
          { backgroundColor: "#e2f2ff" },
      }),
    },
  };

  return (
    <>
      <NewDataTable {...options} />
      <AppDialog
        open={subId > 0}
        title={"Delete Subscription"}
        maxWidth="md"
        handleClose={() => { setSubId(0); }}
      >
        <ConfirmModal
          handleClose={() => { setSubId(0); }}
          alertAction={handleDeleteSubscription}
          message={`Do you wish to Delete the subscription for ${username || ""}?`}
          buttonText={"Delete"}
          buttonText2={"Cancel"} />
      </AppDialog>
    </>
  )
}


export function GetContactAccessSubscriptionsColumns(deleteClick) {
  return [
    {
      header: "Delete",
      size: 60,
      Cell: function ({ row }) {
        return (
          <NewDataGridAction
            row={row?.original}
            onClick={() => deleteClick(row?.original)}
            label={"Delete"}
          />
        );
      },
    },

    {
      header: "Scope",
      accessorKey: "LevelText",
      size: 80,
    },
    {
      header: "Report",
      accessorKey: "Report",
      size: 150,
    },
    {
      header: "Weekly",
      accessorKey: "IsWeekly",
      size: 80,
      Cell: ({ renderedCellValue }) => (renderedCellValue ? "Yes" : ""),
    },
    {
      header: "Monthly",
      accessorKey: "IsMonthly",
      Cell: ({ renderedCellValue }) => (renderedCellValue ? "Yes" : ""),
      size: 80,
    },
    {
      header: "Added",
      accessorKey: "Added",
      Cell: ({ renderedCellValue }) => toDateTimeFormat(renderedCellValue),
      size: 105,
    },
    {
      header: "LastSent",
      accessorKey: "LastSent",
      Cell: ({ renderedCellValue }) => toDateTimeFormat(renderedCellValue),
      size: 105,
    },
    {
      header: "Product",
      accessorKey: "Product",
      size: 110,
    },
    {
      header: "Parent",
      accessorKey: "Parent",
      size: 100,
    },
    {
      header: "Customer",
      accessorKey: "Customer",
      size: 150,
    },
    {
      header: "Site",
      accessorKey: "Site",
      size: 150,
    },
    {
      header: "Unit",
      accessorKey: "Unit",
      size: 150,
    },
    {
      header: "Component",
      accessorKey: "Component",
      size: 150,
    },
    {
      header: "SiteSet",
      accessorKey: "SiteSet",
      size: 150,
    },
  ];
}
